export default "__VITE_ASSET__DU36Q_tb__"